const infos = document.querySelectorAll('.additional__info__product__wrapper');

infos.forEach((info) => {
  info.addEventListener('click', () => {
    const desc = info.querySelector('.info__desc');

    desc.classList.toggle('active');
    info.classList.toggle('active');
  });
});
